import { render, staticRenderFns } from "./errors-snackbar.vue?vue&type=template&id=067dc666&scoped=true"
import script from "./errors-snackbar.vue?vue&type=script&lang=js"
export * from "./errors-snackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067dc666",
  null
  
)

export default component.exports